'use client'

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "./Payment.css";
import {
  loadTossPayments,
  TossPaymentsWidgets,
} from "@tosspayments/tosspayments-sdk";
import { kwaFormat, PlanDetails, plans } from "../../utils/UtilsFunc";
import { useApi } from "../../hooks/ApiProvider";
import { number } from "framer-motion";
import Modals from "../Modals/Modals";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";

// Toss Payments 환경변수 설정
// .env 파일에 다음 변수들을 설정하세요:
// REACT_APP_TOSS_TEST_MODE=true (테스트 모드 활성화)
// REACT_APP_TOSS_TEST_CLIENT_KEY=test_gck_E92LAa5PVbb7jmZb607zV7YmpXyJ (테스트용 클라이언트 키)
// REACT_APP_TOSS_CLIENT_KEY=live_gck_4yKeq5bgrpzgPNwwJ2Mp3GX0lzW6 (실제 운영용 클라이언트 키)
// REACT_APP_TOSS_CUSTOMER_KEY=utopso3579 (고객 키)

// 테스트 모드에 따른 클라이언트 키 선택
// REACT_APP_TOSS_TEST_MODE가 참이면 REACT_APP_TOSS_TEST_CLIENT_KEY를 사용
// REACT_APP_TOSS_TEST_CLIENT_KEY가 없거나 빈 값이면 REACT_APP_TOSS_CLIENT_KEY를 사용
const isTestMode = process.env.REACT_APP_TOSS_TEST_MODE === 'true';
const clientKey = isTestMode 
  ? (process.env.REACT_APP_TOSS_TEST_CLIENT_KEY || process.env.REACT_APP_TOSS_CLIENT_KEY || "")
  : (process.env.REACT_APP_TOSS_CLIENT_KEY || "");
const customerKey = process.env.REACT_APP_TOSS_CUSTOMER_KEY || "";

// 환경변수 검증 함수 (빌드 시점에 실행됨)
const validateEnvironmentVariables = () => {
  if (isTestMode && !process.env.REACT_APP_TOSS_TEST_CLIENT_KEY) {
    console.warn('⚠️ REACT_APP_TOSS_TEST_MODE가 true이지만 REACT_APP_TOSS_TEST_CLIENT_KEY가 설정되지 않았습니다. REACT_APP_TOSS_CLIENT_KEY를 사용합니다.');
  }
  
  if (!process.env.REACT_APP_TOSS_CLIENT_KEY) {
    console.error('❌ REACT_APP_TOSS_CLIENT_KEY가 설정되지 않았습니다. Toss Payments가 작동하지 않을 수 있습니다.');
  }
  
  if (!process.env.REACT_APP_TOSS_CUSTOMER_KEY) {
    console.error('❌ REACT_APP_TOSS_CUSTOMER_KEY가 설정되지 않았습니다. Toss Payments가 작동하지 않을 수 있습니다.');
  }
};

// 빌드 시점에 환경변수 검증 실행
validateEnvironmentVariables();

const Payment = () => {
  
  console.log(isTestMode,'/[isTestMode]')
  
  const { isAuthenticated, isEmbed, isLoading: membershipLoading } = useMembership();
  const { state } = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { issueOrder } = useApi();

  const [widgets, setWidgets] = useState<TossPaymentsWidgets | null>(null);
  const [paymentMethod, setPaymentMethod] = useState<any>(null);
  const [amount, setAmount] = useState({
    currency: "KRW",
    value: 0,
  });
  const [procInfo, setProcInfo] = useState<PlanDetails | undefined>(undefined);
  const [show, setShow] = useState(false);
  const [errorMess, setErrorMess] = useState<any>(``);

  const getReady = async () => {
    try {
      if (clientKey === "" || customerKey === "") {
        throw new Error(
          "서버 동작에 문제가 있습니다. 잠시 후 사용 하시기 바랍니다."
        );
      }

      console.log(clientKey, customerKey,`/[clientKey, customerKey]`)

      const tossPayments = await loadTossPayments(clientKey);
      const widget = tossPayments.widgets({ customerKey });
      const plansInfo = state?.plan;
      setProcInfo(plansInfo);
      setAmount({ ...amount, value: plansInfo?.price });
      setWidgets(widget);
    } catch (err) {
      console.error(err, "/[not found toss!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!]");
    }
  };

  const renderWidget = async () => {
    if (widgets == null) {
      return;
    }
    await widgets.setAmount(amount);
    const paymentMethodWidget = await widgets.renderPaymentMethods({
      selector: "#pay_select_widget",
      variantKey: "DEFAULT",
    });

    // await widgets.renderAgreement({
    //   selector: "#policy_widget",
    //   variantKey: "AGREEMENT",
    // });

    const paymentMethod = await paymentMethodWidget.getSelectedPaymentMethod();
    setPaymentMethod(paymentMethod);
    paymentMethodWidget.on("paymentMethodSelect", (selectedPaymentMethod) => {
      setPaymentMethod(selectedPaymentMethod.code);
    });
  };

  const onHandlePay = async () => {
    try {
      const orderData = {
        product_id: procInfo?.id,
        amount: amount,
        ...(state?.priceType === "GIFT"
          ? {
              is_gift: true,
              phone_number: state?.phone_number,
            }
          : {}),
      };
      const issueOrderResponse = await issueOrder(orderData);

      if (issueOrderResponse.success !== true) {
        throw new Error(
          `주문 발행에 실패했습니다. ${issueOrderResponse.message}`
        );
      } else {
        console.log("주문 발행 성공:", issueOrderResponse);

        const successUrl = window.location.origin + "/order/order_done";
        const failUrl = window.location.origin + "/order/fail";
        console.log(successUrl, failUrl,`/[successUrl, failUrl]`)

        const { order: issuedOrder } = issueOrderResponse;
        const orderPaymentRequest = {
          ...issuedOrder,
          successUrl: successUrl,
          failUrl: failUrl,
          metadata: {
            ...issuedOrder.metadata,
          },
          windowTarget: "iframe",
        };

        console.log(
          "토스로 결제 요청",
          orderPaymentRequest,
          `/[orderPaymentRequest]`
        );

        const result = await widgets?.requestPayment(orderPaymentRequest);

        console.log(result, "/[result]");
      }
    } catch (error) {
      console.log(error);
      if (error instanceof Error) {
        setErrorMess(error?.message);
        if (
          error?.message === `필수 약관에 동의해주세요.` ||
          error?.message === `취소되었습니다.` ||
          error?.message ===
            `주문 발행에 실패했습니다. 이미 멤버십을 보유 하고 있습니다.`
        ) {
          setShow(true);
        }
      }
      // setShow(true);
    }
  };

  const totalPrice = () => {
    if (procInfo) {
      let answer = Number(procInfo?.originalPrice) - Number(procInfo?.price);
      return "-" + kwaFormat(answer);
    }
  };

  useEffect(() => {
    if (isAuthenticated && !membershipLoading) {
      getReady();
    }
  }, [clientKey, customerKey, isAuthenticated, membershipLoading]);

  useEffect(() => {
    if (widgets) {
      renderWidget();
    }
  }, [widgets]);

  //console.log(searchParams,`/[searchParams--------->]`)

  return (
    <>
      {isEmbed() && (
        <div className={`mobile_app_header`} style={{ background: "#fff" }}>
          <button
            onClick={() => navigate(-1)}
            className={`btn btn_back`}
          ></button>
        </div>
      )}
      {isAuthenticated && (
        <div className={`content_wrap payment ${isEmbed() ? `app` : ``}`}>
          <div className={`section_wrap sec_wrap_1`}>
            <div
              className={`flex flex-wrap items-start max-w-[1172px] m-auto sec_wrap_1_children`}
            >
              <div className={`sec sec_1`}>
                <div className={`small_wrap`}>
                  <div
                    className={`price_box flex items-center justify-between max-md:hidden`}
                  >
                    <div className={`body1_sb`}>
                      {procInfo?.name} 플랜
                      {state?.priceType === `GIFT` && (
                        <span className={`sp-outline-primary`}>선물용</span>
                      )}
                    </div>
                    <div className={`text-right`}>
                      <p className={`caption`}>
                        <del>{kwaFormat(procInfo?.originalPrice)}원</del>
                      </p>
                      <p className={`h4_sb`}>{kwaFormat(procInfo?.price)}원</p>
                    </div>
                  </div>
                  <div className={`payment_box`}>
                    <h3 className={`h3`}>결제 금액</h3>
                    <div className={`proc_info`}>
                      <ul className={`price_ul`}>
                        <li>
                          <div className={`tit body1`}>상품명</div>
                          <div className={`txt body1_sb`}>
                            {procInfo?.name} 플랜
                          </div>
                        </li>
                        <li>
                          <div className={`tit body1`}>정가</div>
                          <div className={`txt body1_sb`}>
                            {kwaFormat(procInfo?.originalPrice)}원
                          </div>
                        </li>
                        <li>
                          <div className={`tit body1`}>할인 금액</div>
                          <div className={`txt body1_sb accent`}>
                            {totalPrice()}원
                          </div>
                        </li>
                      </ul>
                      <div
                        className={`total_price flex items-center justify-between`}
                      >
                        <div className={`h3`}>최종 결제 금액</div>
                        <div className={`h3 success`}>
                          {kwaFormat(procInfo?.price)}원
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`sec sec_2 mt-1`}>
                <div id={`pay_select_widget`}></div>
                <div id={`policy_widget`}></div>
              </div>
            </div>
            {/*<div className={`sec`}>*/}
            {/*	<div id={`pay_select_widget`}></div>*/}
            {/*	<div id={`policy_widget`}></div>*/}
            {/*</div>*/}
          </div>
          {widgets !== null && (
            <div className={`footer_btn`}>
              <div className={`btn_group`}>
                <div className={`flex items-center justify-center`}>
                  <button
                    onClick={onHandlePay}
                    className={`btn w-[100%] btn-primary`}
                  >
                    결제하기
                  </button>
                </div>
                <p className={`caption text-center`}>
                  달마다 결제되지 않아요. 한 번 결제로 책을 완성할 수 있어요.
                </p>
              </div>
            </div>
          )}
          <Modals
            navigate={navigate} // 내비
            show={show}
            message={errorMess}
            alertType={`${
              errorMess ===
              `주문 발행에 실패했습니다. 이미 멤버십을 보유 하고 있습니다.`
                ? `using_user`
                : `default`
            }`}
            onClose={(res: any) => setShow(res)}
          />
        </div>
      )}
    </>
  );
};
export default Payment;
